export { default } from "./Tag.component";
